// <div data-controller="wv--groups">
//
// </div>
import { Controller } from "stimulus";
import api from "utils/api";
import UserAgent from "utils/user_agent";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [
      "groupOption", "submitButton", "groupsContainer",
    "answerContainer", "answerInputContainer"
  ];
  static classes = [ "" ]
  static values = {
    guideUrl: String,
  };

  initialize() {

  }

  get karrotBridgeController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById("karrotBridgeController"), "components--karrot-bridge")
  }

  get selectedGroup() {
    let group;
    this.groupOptionTargets.forEach((groupOption) => {
      if (groupOption.checked) {
        group = groupOption;
      }
    });
    return group;
  }

  checkValidity() {
    const selectedGroup = this.selectedGroup;

    if (selectedGroup) {
      if (selectedGroup.id === "question") {
        this.showAnswerSheet();

        return;
      } else {
        this.answerContainerTarget.classList.add("hidden");
      }

      this.submitButtonTarget.innerText = `Join ${selectedGroup.dataset.groupName}`;
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.classList.remove("karrot-button-disabled");
    } else {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.classList.add("karrot-button-disabled");
    }
  }

  showAnswerSheet() {
    this.submitButtonTarget.innerText = `Submit suggestion`
    this.answerContainerTarget.classList.remove("hidden");

    if (this.answerInputContainerTarget.value.length > 1) {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.classList.remove("karrot-button-disabled");
    } else {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.classList.add("karrot-button-disabled");
      this.answerInputContainerTarget.required = true;
      this.answerInputContainerTarget.focus();
      this.answerInputContainerTarget.scrollIntoView({behavior: "smooth"});
    }
  }

  async submit(e) {
    const selectedGroup = this.selectedGroup;

    if (selectedGroup) {
      if (selectedGroup.id === "question") {
        const response = await api.post(`/api/v23/users/me/flea_market_groups/answer.json`, {
          explain: this.answerInputContainerTarget.value,
        }, this.karrotBridgeController.requestHeader)

        this.karrotBridgeController.bridge.openToast({ toast: { body: "✔️ We’ll let you know when we open a group for your condo!" } });
        this.karrotBridgeController.bridge.closeRouter();
      } else {
        const { appSchemeUrl } = selectedGroup.dataset;
        window.location.href = appSchemeUrl;
        this.karrotBridgeController.bridge.closeRouter();
      }
    } else {
      alert("Please select your Condo");
    }
  }

  checkLegacyVersion(event) {
    const { app, user } = event.detail;
    const { userAgent } = app;
    const user_agent = new UserAgent(userAgent);

    if (user_agent.os === "Android" && user_agent.version_code < 224400) {
      this.karrotBridgeController.closeAndRedirect(this.guideUrlValue);
    }
  }

  questionTemplate() {
    return `<div class="relative flex items-center">
            <div class="flex h-5 items-center">
              <input id="question"
                     name="group"
                     type="radio"
                     required
                     data-wv--groups-target="groupOption"
                     data-action="change->wv--groups#checkValidity"
                     class="h-5 w-5 border-gray-300 dark:border-gray-600 dark:bg-gray-700 text-karrot-carrot500 dark:text-karrot-carrot500 focus:ring-karrot-carrot500">
            </div>
            <div class="ml-3 text-sm">
              <label for="question" class="w-full block">
                <p class="text-lg font-medium cursor-pointer text-gray-800 dark:text-gray-200">Can't find your condo?</p>
                <p class="text-gray-600 dark:text-gray-400">Suggest a new group by entering the name of your condo.</p>
              </label>
            </div>  
          </div>`
  }

  renderGroups(groups) {
    let groupOptions = "";
    groups.forEach((group) => {
      groupOptions += `<div class="flex items-center">
            <input id="group-${group.id}"
                   name="group"
                   type="radio"
                   required
                   data-wv--groups-target="groupOption"
                   data-action="change->wv--groups#checkValidity"
                   data-group-name="${group.name}"
                   data-app-scheme-url="${group.join_app_scheme_url}"
                   class="h-5 w-5 border-gray-300 dark:border-gray-600 dark:bg-gray-700 text-karrot-carrot500 dark:text-karrot-carrot500 focus:ring-karrot-carrot500">
            <label for="group-${group.id}" class="ml-3 w-full block text-lg font-medium cursor-pointer text-gray-800 dark:text-gray-200">${group.name}</label>
          </div>`;
    })
    groupOptions += this.questionTemplate();
    this.groupsContainerTarget.insertAdjacentHTML("beforeend", groupOptions);
  }

  async listAvailableGroups(event) {
    const response = await api.get(`/api/v23/users/me/flea_market_groups/available.json`, {
      tag: "condo",
    }, this.karrotBridgeController.requestHeader)

    if (response.data.status) {
      alert(response.data.status.message);
      this.karrotBridgeController.bridge.closeRouter();
    }

    const { flea_market_groups } = response.data;
    if (flea_market_groups.length === 1) {
      this.karrotBridgeController.closeAndRedirect(flea_market_groups[0].join_app_scheme_url);
    } else {
      this.renderGroups(flea_market_groups);
    }

    // 이 부분 어딘가 상위레벨로 옮겨져야 함.
    this.karrotBridgeController.loadingCompleted();
  }

  connect() {
    this.checkValidity();
  }

  disconnect() {

  }
}
